import { ThemeConfig } from "antd";

export const themeConfig: ThemeConfig = {
  token: {},
  components: {},
};
